import buttonGenerator from './buttonGenerator';
export const Default = buttonGenerator('defaultButton', 'default', true);
export const Primary = buttonGenerator('defaultButton', 'primary', true);
export const Destructive = buttonGenerator('defaultButton', 'destructive', true);
export const Safe = buttonGenerator('defaultButton', 'safe', true);
export const Outline = buttonGenerator('defaultButton', 'outline', true);
export const Yellow = buttonGenerator('defaultButton', 'yellow', true);
//# sourceMappingURL=LinkButton.js.map